export default __webpack_public_path__ + "static/media/goes-without-saying.04e3d7bd.ogg";